"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.std = exports.median = void 0;
const mean_1 = __importDefault(require("lodash-es/mean"));
const calculateSortedMedian = (value) => {
    const middle1 = value[value.length / 2 - 1];
    const middle2 = value[value.length / 2];
    return (middle1 + middle2) / 2;
};
const median = (value) => {
    if (!value.length) {
        throw new Error("Cannot calculate median of an empty array");
    }
    const sortedNumbers = [...value].sort((a, b) => a - b);
    return sortedNumbers.length % 2 === 0
        ? calculateSortedMedian(sortedNumbers)
        : sortedNumbers[Math.floor(sortedNumbers.length / 2)];
};
exports.median = median;
const std = (value) => {
    if (!value.length) {
        throw new Error("Cannot calculate standard deviation of empty array");
    }
    if (value.length === 1) {
        return 0;
    }
    const meanValue = (0, mean_1.default)(value);
    return Math.sqrt(value.reduce((acc, num) => acc + Math.pow(num - meanValue, 2), 0) /
        (value.length - 1));
};
exports.std = std;
